import React from 'react';
import { Container, Row, Col, Nav, Tab } from 'react-bootstrap';
import CustomDomains from './CustomDomains';
import ApiKeys from './ApiKeys';

/**
 * Pro Features component that displays premium features for pro users
 * Contains tabs for Custom Domains and API Keys management
 */
const ProFeatures = () => {
  return (
    <Container fluid className="p-0">
      <div className="page-header">
        <h1>Pro Features</h1>
        <p>Manage your premium features like custom domains and API keys</p>
      </div>
      
      <Tab.Container defaultActiveKey="domains">
        <Row>
          <Col lg={12}>
            <Nav variant="tabs" className="mb-4">
              <Nav.Item>
                <Nav.Link eventKey="domains">Custom Domains</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="api-keys">API Keys</Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <Tab.Content>
              <Tab.Pane eventKey="domains">
                <CustomDomains />
              </Tab.Pane>
              <Tab.Pane eventKey="api-keys">
                <ApiKeys />
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </Container>
  );
};

export default ProFeatures;
